import { DateTime } from 'luxon'
import { store } from '../store'
import { messagesSelectors } from 'store/messages'
import ObjectID from 'bson-objectid'
import { settingsSelectors } from 'store/settings'
import { findParticipantsByRole } from 'utils/chats'
import { Chat, ChatRoleEnum, Participant } from 'types/chat'

export const createUserMessage = (message: string) => {
  const userMessageId = String(ObjectID())
  const state = store.getState()
  const currentChat = messagesSelectors.currentChat(state) as Chat
  const isLogged = settingsSelectors.isLogged(state)

  const participant = findParticipantsByRole(
    currentChat,
    isLogged ? ChatRoleEnum.USER : ChatRoleEnum.GUEST,
  ) as Participant

  console.debug({ currentChat, isLogged, participant })

  return {
    message: message,
    timestamp: DateTime.now().toMillis(),
    createdAt: String(DateTime.now().toISO()),
    _id: userMessageId,
    senderId: participant?.userId,
    chatSenderRole: participant?.role,
  }
}
